export default __webpack_public_path__ + "static/media/renner@2x.38ed89da.png";